import React, { useState } from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { FaFilePdf, FaDownload, FaEye, FaCertificate, FaShieldAlt, FaCheckCircle } from "react-icons/fa";
import banner from "../Assests/80g_banner.png";
import CommonBanner from "../Components/Common";
import examplePDF from "./80g.pdf";
import examplePDF2 from "./12a.pdf";
import "./Provision.css";
import { Link, useNavigate } from "react-router-dom";

const Provision = () => {
  const [loading, setLoading] = useState({});
  const navigate = useNavigate();
  const handleViewPDF = (pdf, name) => {
    setLoading(prev => ({ ...prev, [name]: true }));
    window.open(pdf, "_blank");
    setTimeout(() => {
      setLoading(prev => ({ ...prev, [name]: false }));
    }, 1000);
  };

  const handleDownloadPDF = (pdf, name) => {
    const link = document.createElement("a");
    link.href = pdf;
    link.download = `${name}.pdf`;
    link.click();
  };

  const certificates = [
    {
      id: "80g",
      title: "80G Certification",
      description: "Tax exemption under Section 80G of the Income Tax Act",
      pdf: examplePDF,
      icon: FaCertificate,
      color: "#F56A01",
      benefits: [
        "Tax deduction on donations",
        "50% exemption available",
        "Valid for 5 years"
      ]
    },
    {
      id: "12a",
      title: "12A Certification",
      description: "Registration under Section 12A of the Income Tax Act",
      pdf: examplePDF2,
      icon: FaShieldAlt,
      color: "#F56A01",
      benefits: [
        "Income tax exemption",
        "Valid for lifetime",
        "Enhanced credibility"
      ]
    }
  ];

  return (
    <>
      <CommonBanner image={banner} />

      <div className="provision-page">
        <Container>
          {/* Header Section */}
          <div className="provision-header">
            <div className="header-badge">
              <FaFilePdf className="badge-icon" />
              <span>80G / 12A Certification</span>
            </div>
            <h1 className="provision-title">
              Tax Exemption <span className="highlight">Certificates</span>
            </h1>
            <p className="provision-subtitle">
              Your donations to LSSF Trust are eligible for tax benefits under these certifications
            </p>
            <div className="header-decoration">
              <span className="decoration-line"></span>
              <span className="decoration-diamond">✦</span>
              <span className="decoration-line"></span>
            </div>
          </div>

          {/* Certificates Grid */}
          <Row className="certificates-grid">
            {certificates.map((cert, index) => (
              <Col lg={6} md={12} key={cert.id} className="mb-4">
                <div className="certificate-card" style={{ animationDelay: `${index * 150}ms` }}>
                  <div className="card-glow" style={{ background: `radial-gradient(circle at 50% 50%, ${cert.color}20, transparent)` }}></div>

                  <div className="card-header">
                    <div className="icon-wrapper" style={{ background: `linear-gradient(135deg, ${cert.color}, ${cert.color}dd)` }}>
                      <cert.icon className="cert-icon" />
                    </div>
                    <div className="cert-badge">Registered</div>
                  </div>

                  <h2 className="cert-title">{cert.title}</h2>
                  <p className="cert-description">{cert.description}</p>

                  {/* Benefits List */}
                  <div className="benefits-list">
                    {cert.benefits.map((benefit, idx) => (
                      <div key={idx} className="benefit-item">
                        <FaCheckCircle className="benefit-icon" style={{ color: cert.color }} />
                        <span>{benefit}</span>
                      </div>
                    ))}
                  </div>

                  {/* Action Buttons */}
                  <div className="card-actions">
                    <Button
                      variant="outline"
                      className="action-btn view-btn"
                      style={{ borderColor: cert.color, color: cert.color }}
                      onClick={() => handleViewPDF(cert.pdf, cert.id)}
                      disabled={loading[cert.id]}
                    >
                      {loading[cert.id] ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2"></span>
                          Loading...
                        </>
                      ) : (
                        <>
                          <FaEye className="btn-icon" />
                          View Certificate
                        </>
                      )}
                    </Button>

                    <Button
                      className="action-btn download-btn"
                      style={{ background: `linear-gradient(135deg, ${cert.color}, ${cert.color}dd)` }}
                      onClick={() => handleDownloadPDF(cert.pdf, cert.title)}
                    >
                      <FaDownload className="btn-icon" />
                      Download PDF
                    </Button>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          {/* Info Section */}
          <div className="info-section">
            <div className="info-content">
              <h3>Why These Certifications Matter?</h3>
              <div className="info-grid">
                <div className="info-card">
                  <div className="info-icon">✓</div>
                  <p>100% Tax exemption on donations</p>
                </div>
                <div className="info-card">
                  <div className="info-icon">✓</div>
                  <p>Government recognized trust</p>
                </div>
                <div className="info-card">
                  <div className="info-icon">✓</div>
                  <p>Transparent donation process</p>
                </div>
                <div className="info-card">
                  <div className="info-icon">✓</div>
                  <p>Annual compliance maintained</p>
                </div>
              </div>
            </div>
          </div>

          {/* Call to Action */}
          <div className="cta-section">
            <h4>Ready to Make a Difference?</h4>
            <p>Your contribution can transform lives while giving you tax benefits</p>
            <Link to='/whydonation'>
              <Button className="cta-button" onClick={()=>navigate("/whydonation")}>
                Donate Now
              </Button>
            </Link>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Provision;